<template>
    <Transition>
    <div class="fondo_transparente" v-if="isVisible">
      <div class="ventana_modal" id="mydiv">
        <XCerrarModal sizeX="P" @click="cerrar"/>
        <div class="alert" >
          <h3 :style= "{ color: colorMensaje }">{{ modoMensaje }}</h3>
          <h5>{{ params.msg }}</h5>
          <button class="Btn-elim" @click="eliminar" v-show="mostrar">Eliminar</button>
        </div>
      </div>
    </div>
    </Transition>
 </template>

<script>
import XCerrarModal from './XCerrarModal.vue'
export default {
  components: { XCerrarModal },
  data () {
    return {
      tipo: {
        S: 'Éxito',
        I: 'Información',
        W: 'Advertencia',
        E: 'Error'
      },
      tipoMensaje: '',
      colorTexto: {
        S: 'rgb(30, 255, 0)',
        I: 'rgb(0, 217, 255)',
        W: 'rgb(255, 160, 0)',
        E: 'rgb(255, 81, 0)'
      },
      isVisible: false,
      params: {
        msg: '',
        type: '',
        confirm: ''
      }
    }
  },
  mounted () {
    this.$root.emitter.on('my-event', this.showModal)
  },
  methods: {
    cerrar () {
      this.isVisible = false
      this.$root.emitter.emit('modal-response', 'cancelar')
    },
    eliminar () {
      this.$root.emitter.emit('modal-response', 'borrar')
      this.cerrar()
    },
    showModal (payload) {
      console.log('showModal called with', payload)
      this.params = payload
      this.isVisible = true
    }
  },
  computed: {
    modoMensaje () {
      const T = this.params.type
      return this.tipo[T]
    },
    colorMensaje () {
      const T = this.params.type
      return this.colorTexto[T]
    },
    mostrar () {
      return this.params.confirm === 'C'
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}
.ventana_modal{
    font-family: SegoeL;
    background: -webkit-linear-gradient(100deg, rgba(180, 180, 180, 0.97),
    rgba(214, 214, 214, 0.97),rgba(180, 180, 180, 0.97), rgba(68, 68, 68, 0.97));
    /* background-color: rgb(255, 75, 4, 0.9); */
    width: 400px;
    min-height: 100px;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: fixed;
    border-radius: 5px;
    z-index: 100;
    /* box-shadow: rgb(108, 108, 108) 5px 5px 7px; */

}
.alert{
  color: rgba(255, 255, 255, 0.9);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  flex-direction: column;
}
h3 {
  text-align: left;
  padding: 6px 0 0 18px;
  font-weight: normal;
}
h5 {
  text-align: left;
  padding: 14px 0 0 18px;
  font-weight: normal;
  color: black;
}
.Btn-elim{
  width: 25%;
  height: 27px;
  cursor: pointer;
  align-self: flex-end;
  margin-right: 14px;
  margin-bottom: 8px;
  border: solid 0.5px rgb(255, 160, 0);
  border-radius: 4px;
}
.v-enter-active, .v-leave-active {
  transition: opacity 0.4s ease, transform 0.4s;
}
.v-enter-from, .v-leave-to {
  opacity: 0;
  transform: translateY(-25px);
}
@media screen and (max-width: 575px){
  .ventana_modal{
    width: 90%;
  }

}
</style>
